import React from 'react';
import RemoteLocalSettings, { IRemoteLocalSettingsProps } from './RemoteLocalSettings';

import { Stack } from '@fluentui/react';
import {
    remoteSettingsContainerStyle
} from './styles/CommandPanel.styles';

export enum RemoteCommandPanelTypes {
    None = 'none',
    Settings = 'Settings'
}

export default (props: IRemoteLocalSettingsProps): JSX.Element => {
    return (
        <Stack >
            <Stack.Item>
                <div className={remoteSettingsContainerStyle}>
                    <RemoteLocalSettings {...props}
                    />
                </div>
            </Stack.Item>

        </Stack>
    );
};